// Consensus response entries (MAT-07): one answer per question and scenario, recorded by the instructor, plus
// optional evaluator unit and two comments transcribed from the discussion.
import { z } from "zod";
import { optionalText, version } from "../setup.ts";
import { MATURITY_LIMITS, nodeId } from "./definition.ts";

export const ANSWERS = ["yes", "partial", "no"] as const;
export type Answer = (typeof ANSWERS)[number];

export const responseEntrySchema = z.strictObject({
  answer: z.enum(ANSWERS, { error: "Resposta inválida." }).nullable().default(null),
  evaluator_unit: optionalText(MATURITY_LIMITS.label).default(null),
  group_comment: optionalText(MATURITY_LIMITS.comment).default(null),
  consultant_comment: optionalText(MATURITY_LIMITS.comment).default(null),
});
export type ResponseEntry = z.output<typeof responseEntrySchema>;
export type Responses = Record<string, ResponseEntry>;

export const responsesSchema = z
  .record(nodeId, responseEntrySchema)
  .refine((r) => Object.keys(r).length <= MATURITY_LIMITS.questions, `Use no máximo ${MATURITY_LIMITS.questions} quesitos.`);

export const scenarioSaveSchema = z.strictObject({ expected_version: version, responses: responsesSchema });

export const EMPTY_ENTRY: ResponseEntry = { answer: null, evaluator_unit: null, group_comment: null, consultant_comment: null };
export const isEmptyEntry = (e: ResponseEntry) => !e.answer && !e.evaluator_unit && !e.group_comment && !e.consultant_comment;

/** Canonical stored form: untouched questions have no entry, so "Sem resposta" and an omitted id are the same. */
export function canonical(r: Responses): Responses {
  const out: Responses = {};
  for (const id of Object.keys(r).sort()) if (!isEmptyEntry(r[id]!)) out[id] = r[id]!;
  return out;
}
